/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';

import { ILayoutPreferencesState } from '../state';

export enum ELayoutPreferencesActions {
  GetLayoutPreferences = '[Layout Preferences] Get Layout Preferences',
  GetLayoutPreferencesSuccess = '[Layout Preferences] Get Layout Preferences Success',
  UpdateLayoutPreferences = '[Layout Preferences] Update Layout Preferences',
  UpdateIsClusteringByDefaultTriggered = '[Layout Preferences] Update Is Clustering By Default Triggered'
}

export class GetLayoutPreferences implements Action {
  public readonly type = ELayoutPreferencesActions.GetLayoutPreferences;
}

export class GetLayoutPreferencesSuccess implements Action {
  public readonly type = ELayoutPreferencesActions.GetLayoutPreferencesSuccess;

  constructor(public payload: ILayoutPreferencesState) {}
}

export class UpdateLayoutPreferences implements Action {
  public readonly type = ELayoutPreferencesActions.UpdateLayoutPreferences;

  constructor(public payload: ILayoutPreferencesState) {}
}

export class UpdateIsClusteringByDefaultTriggered implements Action {
  public readonly type = ELayoutPreferencesActions.UpdateIsClusteringByDefaultTriggered;

  constructor(public payload: boolean) {}
}

export type LayoutPreferencesActions =
  | GetLayoutPreferences
  | GetLayoutPreferencesSuccess
  | UpdateLayoutPreferences
  | UpdateIsClusteringByDefaultTriggered;
